module.exports = __webpack_public_path__ + "img/type_03.9318fc14.png";